import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type NotificationTriggeredJournalEvent from "./notification-triggered-journal-event";

//---- Automatically generated, don't update this part ----

export default class NotificationProcessedJournalEvent extends JournalEvent {
  static override type = "notification-processed-journal-event";

  /**
   * What or who triggered the notification processing.
   */
  @attr("string") declare source: string;

  static override validations(intl: IntlService) {
    return {
      notificationTriggeredJournalEvent: validatePresence({
        presence: true,
        description: intl.t(
          "validations.notification-processed-journal-event.notification-triggered-journal-event"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.notification-processed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("notification-triggered-journal-event", {
    async: false,
    inverse: "notificationProcessedJournalEvent"
  })
  declare notificationTriggeredJournalEvent: NotificationTriggeredJournalEvent;

  override get description(): string | undefined {
    return (
      this.notificationTriggeredJournalEvent.labelWithoutValue ??
      this.notificationTriggeredJournalEvent.label
    );
  }

  override get summary() {
    const description =
      this.source == "auto:alerts-treated"
        ? "Traitée automatiquement "
        : "Traitée ";

    return Object.assign(super.summary, {
      date: this.notificationTriggeredJournalEvent.occurredAt.toISOString(),
      description
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "notification-processed-journal-event": NotificationProcessedJournalEvent;
  }
}
